import { render, staticRenderFns } from "./DatosRci.vue?vue&type=template&id=b3158744&"
import script from "./DatosRci.vue?vue&type=script&lang=js&"
export * from "./DatosRci.vue?vue&type=script&lang=js&"
import style0 from "./DatosRci.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports